import { gql } from '@apollo/client';

import { COMPANY_FRAGMENT } from '../fragments';

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($input: UpdateCompanyInput!) {
    updateCompany(input: $input) {
      ...companyValues
    }
  }
  ${COMPANY_FRAGMENT}
`;

export const UPDATE_TIMEFRAME = gql`
  mutation UpdateTimeFrame($input: UpdateTimeFrameInput!) {
    updateTimeFrame(input: $input) {
      id
      shortTermUpperBound
      mediumTermUpperBound
    }
  }
`;
